module.exports = __webpack_public_path__ + "assets/_card-2.77dcca3c.svg";